import ActivityLog from '@components/activityLog/ActivityLog'
import { useAppSelector } from '@store/hooks'
import { selectSelectedNotification } from '@store/NotificationReducer'
import { Spin } from 'antd'

const View = () => {
  const item = useAppSelector(selectSelectedNotification())

  if (!item) {
    return <Spin />
  }

  return (
    <ActivityLog.Timeline
      entity="notification"
      entityId={item.id}
      cardProps={{
        style: { maxHeight: 500, overflow: 'scroll', padding: 10 },
      }}
    />
  )
}

export default View
